module.exports = global["PIXI"] = require("-!.\\pixi.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/pixi.js
// module id = 28
// module chunks = 0